import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const requestTimer = message => {
  let toastId;

  const showNotification = () =>
    (toastId = toast.success(message, toastOptions));

  const dismissNotification = () => {
    if (!toastId) {
      return;
    }
    toast.dismiss(toastId);
    toastId = null;
  }

  const startTimer = setTimeout(() => {
    timerExpired();
  }, 5000);

  const endTimer = () => {
    clearTimeout(startTimer);
    dismissNotification();
  };

  const timerExpired = () => showNotification();

  return () => endTimer();
};

const toastOptions = {
  position: toast.POSITION.TOP_RIGHT,
  className: 'notification-success',
  theme: 'colored',
};
